import validationMessages from 'vee-validate/dist/locale/zh_CN';
//citrix.com.cn

const yesNoOptions = [
    {value: "Yes", text: "是"},
    {value: "No", text: "否"}
]

export default {
    privacyLinkLabel: "隐私政策",
    privacyLink: '/zh-cn/about/legal/privacy/',
    privacyText: "Citrix 将根据我们的",
    privacyText2: "处理您的数据",
    resetText: "如果以下表格已经预填写，但并非您的信息，请",
    resetText2: "进行重置。",
    resetLinkText: "单击此处",
    yes: "是",
    no: "否",
    submitBtn: {
        "Submit" : "提交",
        "Get the eBook" : "获取电子书",
        "Watch demo" : "观看演示",
        "Get the kit" : "获取套件",
        "Request a demo": "请求演示",
        "Request a call": "请联络我"
    },
    apjPrivacy:{
        title: "我们如何使用您的个人信息",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") 将根据适用数据保护法律法规和",
        linkText: "Citrix 隐私政策",
        part2: "以及在严格限制访问的情况下使用和储存您的个人信息。 Citrix 将仅按照其隐私政策的规定使用您的个人信息，且不会用于其他用途。 根据其隐私政策，Citrix 可能委托国内或国外业务实体对个人信息进行处理，或与全球其他 Citrix 办事处或子公司共享个人信息，或将个人信息发送至国内或国外第三方。 当您将个人信息提交给 Citrix 时，即表明您同意 Citrix 隐私政策所述的对您个人信息的收集和处理。",
        privacyAccept: "我已阅读并同意 Citrix 隐私政策"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "公司"
        },
        "department": {
            label: "部门",
            options: [
                { value: "Application Management", text: "应用管理" },
                { value: "Consulting Services", text: "咨询服务" },
                { value: "Education / Training", text: "教育/培训" },
                { value: "Engineering", text: "工程设计" },
                { value: "Executive Office / Administration", text: "行政办公室/管理" },
                { value: "Finance / Accounting", text: "财务/会计" },
                { value: "Human Resources", text: "人力资源" },
                { value: "Information Technology - Systems", text: "信息技术-系统" },
                { value: "Legal", text: "法律事宜" },
                { value: "Marketing / PR", text: "营销/公共关系" },
                { value: "Networking", text: "网络" },
                { value: "Operations / Manufacturing", text: "运营/制造" },
                { value: "Pre-Sales / Technical Support", text: "售前/技术支持" },
                { value: "Project Management", text: "项目管理" },
                { value: "Purchasing", text: "采购" },
                { value: "Sales / Bus-Corp Development", text: "销售/企业发展" },
                { value: "Security", text: "安全性" },
                { value: "Web / Online / E-Business", text: "网络/在线/电子商务" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "行业",
            options: [
                { value: "Professional Services", text: "专业服务" },
                { value: "Business Consulting", text: "业务咨询" },
                { value: "Personnel Services", text: "个人服务" },
                { value: "Transportation", text: "交通" },
                { value: "Business/Personal Services", text: "企业/个人服务" },
                { value: "Conglomerate", text: "企业集团" },
                { value: "Insurance", text: "保险" },
                { value: "Utilities", text: "公共事业" },
                { value: "Agriculture", text: "农业" },
                { value: "Publishing/Printing", text: "出版/印刷" },
                { value: "Pharmaceuticals", text: "制药" },
                { value: "Manufacturing", text: "制造行业" },
                { value: "Chemical Manufacturing", text: "化工制造" },
                { value: "Health Care", text: "医疗保健" },
                { value: "Entertainment", text: "娱乐" },
                { value: "Household Services", text: "家政服务" },
                { value: "Engineering", text: "工程设计" },
                { value: "Charitable/Non-Profit", text: "慈善/非盈利" },
                { value: "Real Estate", text: "房地产" },
                { value: "Technology", text: "技术" },
                { value: "Government/National-Federal", text: "政府/国家-联邦" },
                { value: "Government/State-Province", text: "政府/州-省" },
                { value: "Government/Local", text: "政府/当地" },
                { value: "Education", text: "教育行业" },
                { value: "Construction and Design", text: "施工与设计" },
                { value: "Hospitality", text: "服务业" },
                { value: "Service Provider", text: "服务提供商" },
                { value: "Legal", text: "法律事宜" },
                { value: "Consumer Packaged Goods", text: "消费性包装品" },
                { value: "Telecommunication", text: "电信" },
                { value: "E-Commerce", text: "电子商务" },
                { value: "Oil and Gas", text: "石油和天然气" },
                { value: "Mining - All", text: "矿业 - 全部" },
                { value: "Art & Membership", text: "艺术与会员" },
                { value: "Finance", text: "金融行业" },
                { value: "Retail/Wholesale", text: "零售/批发" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "公司规模",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "公司规模",
            options: [
                { value: "5,001 +", text: "5,001 +" },
                { value: "1,001 to 5,000", text: "1,001 至 5,000" },
                { value: "501 to 1,000", text: "501 至 1,000" },
                { value: "251 to 500", text: "251 至 500" },
                { value: "1 to 250", text: "1 至 250 人" }
            ]
        },
        "Address2": {
            label: "地址行2"
        },
        "Address3": {
            label: "地址行3"
        },
        "city": {
            label: "城市"
        },
        "country": {
            label: "国家/地区"
        },
        "email": {
            label: "工作电子邮件"
        },
        "firstName": {
            label: "名字"
        },
        "lastName": {
            label: "姓氏"
        },
        "phone": {
            label: "电话号码"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "邮区/邮政编码"
        },
        "salutation": {
            label: "称呼",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "州/省"
        },
        "address": {
            label: "地址"
        },
        "Job_Title__c": {
            label: "职务",
            options: [
                { value: "IT Manager", text: "IT 经理" },
                { value: "Business Manager", text: "业务经理" },
                { value: "Analyst", text: "分析师" },
                { value: "Assistant", text: "助理" },
                { value: "Student", text: "学生" },
                { value: "Architect", text: "建筑师" },
                { value: "Developer / Programmer", text: "开发人员/程序员" },
                { value: "Director", text: "总监" },
                { value: "Owner / Partner", text: "所有者/合作伙伴" },
                { value: "System Administrator", text: "系统管理员" },
                { value: "Network Administrator / Engineer", text: "网络管理员/工程师" },
                { value: "Consultant", text: "顾问" },
                { value: "C-Level / President / VP", text: "高管层/总裁/副总裁" }
            ]
        },
        "Project_Budget__c": {
            label: "项目预算",
            options: [
                { value: "Yes", text: "是" },
                { value: "No", text: "否" },
                { value: "Unknown", text: "未知" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "按住CTRL键可以选择多个（最多5个)"
        },
        "Purchase_Timeframe__c": {
            label: "购买时间范围",
            options: [
                { value: "3 months or less", text: "3个月以内" },
                { value: "4 to 6 months", text: "4 到 6 个月" },
                { value: "7 months or more", text: "7 个月以上" },
                { value: "No time frame", text: "无时间范围" },
                { value: "Unknown", text: "不确定" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "我们可以给您发电子邮件吗？",
            options: [
                { value: "Yes", text: "是" },
                { value: "No", text: "否" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "是" },
                { value: "No", text: "否" }
            ]
        },
        "OK_to_Call__c": {
            label: "我们可以给您打电话吗？",
            options: [
                { value: "Yes", text: "是" },
                { value: "No", text: "否" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "请销售人员与我联系"
        },
        "Comments_6__c":{
            label: "备注"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "取消订阅所有营销电子邮件通讯。",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "暂停订阅通讯 30 天。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "完备的数字化工作空间（包括应用程序、桌面、文件和移动设备）如何帮助您无论身在何处都能高效地工作。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "如何从任何设备安全访问所有应用程序、桌面和数据。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "如何在混合的多云环境中管理基于单片和微服务的应用交付。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "如何实现您用户所需的常开模式高性能网络。",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "如何通过分析和洞察力来检测安全威胁和性能异常，从而提前阻止威胁，避免威胁切实发生。",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "取消订阅",
        thankyou: "您的电子邮件首选项已更新。如果这是误操作，或者您希望查看自己的偏好，请随时访问我们的“偏好中心”。",
        formDescription: "很抱歉看到您离开。请稍候，并在 Citrix.com 上与我们联系。我们会不断添加新的特色和功能，以确保 Citrix 产品适合于您。",

    },
    preferenceCenter: {
        formTitle: "Citrix 电子邮件偏好中心",
        thankyou: "<h3>订阅变更已确认！</h3><p>您的电子邮件首选项已更新。</p>",
        formDescription: "您的电子邮件和通讯首选项对于我们很重要。我们希望向您发送信息，以帮助您和贵组织更好地开展工作。敬请更新您的电子邮件首选项，以便我们能够确保您从 Citrix 收到您关心的通讯。",
        labelOne: "告诉我们关于您的更多信息",
        labelTwo: "您有兴趣了解哪些主题？",
        labelThree: "您希望如何与您进行通讯？",
    },
    validation: validationMessages
}